define([
	'components/utilities/utilities',
	'components/loader/loader',
	'components/pubsub/pubsub',
	'libs/nanoajax'
], function (utils, loader, pubsub, nanoajax) {
	'use strict';

	/**
	 * AjaxForm
	 * A plugin that add ajax-request to forms.
	 * @version 2.0.4
	 * @exports ajaxForm
	 */
	return function () {
		var ajaxForm = {

			/** Placeholder for base DOM element. */
			el: null,

			/** Placeholder for template (used if this plugin is used with json). */
			template: null,

			/** Target DOM id (the list). */
			targetId: null,

			/** Placeholder for target DOM element (the list). */
			targetEl: null,

			/** Placeholder for array of DOM elements that should be updated on render. */
			syncEls: null,

			/** Placeholder for pager DOM element. */
			pager: null,

			/** Boolean to indicate if there are any ajax-request in progress. */
			requestInProgress: false,

			/** 1 =DOESN'T WORK CORRECTLY RIGHT NOW.  back button navigates between searches. 0 = back button navigates to previous, referring page. */
			supportBackButton: 0,

			/** Selector for items. */
			itemSelector: 'article',

			/** Boolean indicating if to use cache (experimental). */
			useCache: false,

			/** Array which will hold the cache. */
			cache: [],


			/**
			 * Constructor function.
			 * @private
			 */
			_constructor: function () {
				return this;
			},


			/**
			 * The initialization function for this module.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			init: function (el) {
				this.el = el;
				this.targetId = el.getAttribute('aria-controls');
				this.targetEl = document.getElementById(this.targetId);
				this.pager = document.querySelector('[data-type="loadMore"]');

				if (el.getAttribute('data-cache') === 'true') {
					this.useCache = true;
				}

				if (this.targetEl === null) {
					return false;
				}

				if (el.getAttribute('data-itemselector') !== null) {
					this.itemSelector = el.getAttribute('data-itemselector');
				}

				if (el.getAttribute('data-sync') !== null) {
					this.syncEls = el.getAttribute('data-sync').split('|');
				}

				this._loadTemplates();
			},


			/**
			 * Function that loads content through ajax.
			 * @private
			 */
			_load: function () {
				var that = this,
					url = this.el.getAttribute('action'),
					method = this.el.getAttribute('method') || 'GET',
					ajaxUrl = this.el.getAttribute('data-ajaxurl'),
					//loadingMessage = this.el.getAttribute('data-loading-message') || 'Laddar',
					loader = document.getElementById('main-loader'),
					nanoajaxOptions = {
						method: method,
						url: ajaxUrl || url,
						headers: {
							'X-Requested-With': 'XMLHttpRequest'
						}
					};

				if (this.requestInProgress === false) {
					if (method === 'GET') {
						if (url.indexOf('?') !== -1) {
							url = url + '&' + utils.formToQuery(this.el);
						} else {
							url = url + '?' + utils.formToQuery(this.el);
						}
					} else {
						nanoajaxOptions.body = utils.formToQuery(this.el);
					}

					if (this.useCache === true && this.cache[url] !== undefined) {
						this.targetEl.innerHTML = this.cache[url];
						this._pathchange(url);
						return false;
					}

					this._pathchange(url);
					this.requestInProgress = true;
					utils.removeClass(loader, 'is-hidden');

					// Fixes a bug in Chrome
					url = url.indexOf('?') === -1 ? url + '?_=' + utils.getTimestamp() : url + '&_=' + utils.getTimestamp();
					nanoajaxOptions.url = ajaxUrl || url;

					nanoajax.ajax(nanoajaxOptions, function (code, responseText, request) {
						if (code === 200) {
							var ct = request.getResponseHeader('content-type') || '';
							//that.targetEl.innerHTML = '';

							if (ct.indexOf('html') > -1) {
								that._renderHtml(responseText, url);
							}
							else if (ct.indexOf('json') > -1) {
								that._renderJson(responseText, url);
							}
							utils.addClass(loader, 'is-hidden');
							that.requestInProgress = false;
						}
					});
				}
			},


			/**
			 * Function that renders new html-data.
			 * @param {String} data - New data as a string of html.
			 * @param {String} url - The requested url as a string.
			 * @private
			 */
			_renderHtml: function (data, url) {
				var parser = new DOMParser(),
					doc = parser.parseFromString(data, 'text/html'),
					scrollTop = window.pageYOffset || document.documentElement.scrollTop,
					newPager, newItems;

				if (this.el.getAttribute('data-ajaxform-replace') !== 'true') {
					newPager = doc.querySelector('[data-type="loadMore"]');
					newItems = doc.querySelectorAll('#' + this.targetId + ' ' + this.itemSelector);

					for (var i = 0; i < newItems.length; i++) {
						this.targetEl.appendChild(newItems[i]);

						if (i === 0) {
							var firstLink = newItems[i].querySelector('a');

							if (firstLink !== null) {
								firstLink.focus();
							} else {
								newItems[i].focus();
							}
						}
					}

					if (this.pager !== null) {
						if (newPager === null) {
							utils.addClass(this.pager, 'is-hidden');
						} else {
							utils.removeClass(this.pager, 'is-hidden');
							this.pager.setAttribute('href', newPager.getAttribute('href'));
						}
					}
				} else {
					this.targetEl.innerHTML = doc.querySelector('#' + this.targetId).innerHTML;
					window.scrollTo(0, scrollTop);
				}

				if (this.syncEls !== null) {
					this._syncElementsHtml(doc);
				}

				if (this.useCache === true) {
					this.cache[url] = this.targetEl.innerHTML;
				}

				pubsub.publish('/ajaxForm/list/updated');
			},


			/**
			 * Function that sync other elements after update (with HTML-data).
			 * @param {String} data - New data as a string of json.
			 * @private
			 */
			_syncElementsHtml: function (doc) {
				for (var i = 0; i < this.syncEls.length; i++) {
					var el = document.getElementById(this.syncEls[i]),
						newEl = doc.querySelector('#' + this.syncEls[i]);

					if (newEl !== null) {
						el.innerHTML = newEl.innerHTML;
					}
				}

				pubsub.publish('/ajaxForm/sync/updated');
			},


			/**
			 * Function that renders new json-data.
			 * @param {String} data - New data as a string of json.
			 * @param {String} url - The requested url as a string.
			 * @private
			 */
			_renderJson: function (data, url) {
				var html = '',
					oldItems = null,
					newItems = null,
					firstLink;

				try {
					data = JSON.parse(data);
					html = this.template(data);
				} catch (e) {}

				if (this.pager !== null) {
					if (data.pager === undefined || data.pager === null || data.pager === '') {
						utils.addClass(this.pager, 'is-hidden');
					} else {
						utils.removeClass(this.pager, 'is-hidden');
						this.pager.setAttribute('href', data.pager.pagerUrl);
					}
				}

				oldItems = this.targetEl.querySelectorAll(this.itemSelector);
				this.targetEl.insertAdjacentHTML('BeforeEnd', html);
				newItems = this.targetEl.querySelectorAll(this.itemSelector);

				if (this.syncEls !== null) {
					this._syncElementsJson(data);
				}

				if (newItems[oldItems.length] !== null && newItems[oldItems.length] !== undefined) {
					firstLink = newItems[oldItems.length].querySelector('a');
					if (firstLink !== null) {
						firstLink.focus();
					} else {
						newItems[oldItems.length].focus();
					}
				}

				if (this.useCache === true) {
					this.cache[url] = this.targetEl.innerHTML;
				}

				pubsub.publish('/ajaxForm/list/updated');
			},


			/**
			 * Function that sync other elements after update (with JSON-data).
			 * @param {String} data - New data as a string of json.
			 * @private
			 */
			_syncElementsJson: function (data) {
				for (var i = 0; i < this.syncEls.length; i++) {
					var el = document.getElementById(this.syncEls[i]),
						syncWith = el.getAttribute('data-sync-with'),
						template = el.getAttribute('data-sync-template');

					if (template !== null) {
						if (syncWith !== null) {
							el.innerHTML = '';
							el.insertAdjacentHTML('BeforeEnd', el.template(utils.objectByString(data, syncWith)));
						} else {
							el.innerHTML = '';
							el.insertAdjacentHTML('BeforeEnd', el.template(data));
						}
					}

					if (syncWith !== null) {
						el.innerHTML = '';
						el.insertAdjacentHTML('BeforeEnd', utils.objectByString(data, syncWith));
					}
				}
				pubsub.publish('/ajaxForm/sync/updated');
			},


			/**
			 * Function that loads all template-files needed by the ajaxForm.
			 * @private
			 */
			_loadTemplates: function () {
				var that = this,
					templates = [],
					loadedTemplates = 0;

				// Get "base" template for the list
				if (this.el.getAttribute('data-template') !== null) {
					templates.push({ el: this, tpl: this.el.getAttribute('data-template') });
				}

				// See if we have any other elements that wants to be synced with a template.
				if (this.syncEls !== null) {
					for (var i = 0; i < this.syncEls.length; i++) {
						var el = document.getElementById(this.syncEls[i]),
							template = el.getAttribute('data-sync-template');

						if (template !== null) {
							templates.push({ el: el, tpl: template });
						}
					}
				}

				// Initiate if we have no templates, otherwise we initiate after all templates has been loaded.
				if (templates.length === 0) {
					this._initEvents();
				} else {
					for (var j = 0; j < templates.length; j++) {
						var obj = templates[j];

						that._loadTemplate(obj.el, obj.tpl, _loadCallback);
					}
				}

				function _loadCallback () {
					loadedTemplates += 1;

					if (loadedTemplates === templates.length) {
						that._initEvents();
					}
				}
			},


			/**
			 * Function that loads a single template-file for an element.
			 * @param {Object} el - A DOM node which use the template.
			 * @param {String} template - The template name.
			 * @param {Object} callback - An callback function after the template has been loaded.
			 * @private
			 */
			_loadTemplate: function (el, template, callback) {
				require(['../../templates/' + template + '.hbs'], function (tpl) {
					el.template = tpl;
					callback();
				});
			},


			/**
			 * Function that updates the url.
			 * @private
			 */
			_pathchange: function (url) {
				if (utils.hasHistorySupport()) {
					if (this.supportBackButton === 1) {
						window.history.pushState(null, null, url);
					} else {
						window.history.replaceState(null, null, url);
					}
				}
			},


			/**
			 * Initiates events.
			 * @private
			 */
			_initEvents: function () {
				var that = this;

				utils.addEventListener(this.el, 'submit', function (event) {
					if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }

					that._load();
				});

				pubsub.subscribe('/ajaxForm/load', function () {
					that._load();
				});

				pubsub.subscribe('/ajaxForm/sync/update/html', function (doc) {
					setTimeout(function () {
						that._syncElementsHtml(doc);
					}, 500);
				});

				pubsub.subscribe('/ajaxForm/sync/update/json', function (data) {
					setTimeout(function () {
						that._syncElementsJson(data);
					}, 500);
				});
			}
		};

		return ajaxForm._constructor();
	};
});
